module.exports = __webpack_public_path__ + "img/palette.b69fbb60.svg";